import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=0c4cd3b2&scoped=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=0c4cd3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4cd3b2",
  null
  
)

export default component.exports